module.exports = __webpack_public_path__ + "media/images/mailer/logo_transparent-bcb76d614090fa8e48bade2024f1dd07.png";